import React, { useContext } from 'react';
import { ContextualMenuItemType, IconButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { enum__ComponentType, __enum_ChartDataserieInputType, __KPIPeriods, enum__BUTTONKEYS_KPI, enum__PRIVILEGES, __enum_PageMode } from '../../../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import MainAppContext from '../../../../../../MainAppContext';
import BoardAppContext from '../../../../../../BoardAppContext';
import { _checkSecurityUser, _checkSecurityUser_And_ResponsibleInsert } from '../../../../../../common/Helpers/HLP_Security';
import { useSelector } from 'react-redux';
import { isNullUndefined } from '../../../../../../common/Helpers';

function ChangeComponentType(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    const { _boardStructureSpecific: boardStructureSpecific } = useSelector((state) => state.boardViewScope);
    const { _boardStructureGeneric: boardStructureGeneric } = useSelector((state) => state.boardViewScope);
    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    const { _systemRoles: systemRoles } = useSelector((state) => state.boardViewComponentsScope);

    const aux_structure = boardStructureSpecific === null ? boardStructureGeneric : boardStructureSpecific;

    const iconButtonStyles = { root: { float: 'left', height: 'inherit', padding: '10px' } };
    const { 
        inputParam_OnChangeRowDisplayType = null,
        inputParam_OnChangeRowAggregationTime = null,
        inputParam_OnSelectSerieToCompareOnChart = null,
        inputParam_OnChartDataBindClearCompareClick = null,
        inputParam_OnOpenPanel = null,
        inputParam_Component = null,
        inputParam_DataSerie = null,
        inputParam_ClassName = '',
        inputParam_ClassNameParent = '',
        inputParam_UserProps = null,
        inputParam_SetCalendarType = null,
        inputParam_SelectedDataserieToPanel = null,
        inputParam_HideAggregationButtons = false,
        inputParam_ShowOnlyInfoView = true,
    } = props;

    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const _priv_canManipulateSelectedElement = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles)
    const _priv_canCloseDataserie = _checkSecurityUser(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CLOSE);

    const canEdit = (_priv_canManipulateSelectedElement.value && _priv_canManipulateSelectedElement.mode === __enum_PageMode.Edit) || _priv_canManipulateSelectedElement.roleAssignedExistInMatrix

    const _priv_canDelete = _checkSecurityUser(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_VALIDATE)

    return (
                <div className={inputParam_ClassNameParent}>
                    <IconButton
                        menuIconProps={{ iconName: 'MoreVertical' }}
                        role="button"
                        className={`action-menu-list-toolbar ${inputParam_ClassName}`}
                        aria-haspopup
                        styles={iconButtonStyles}
                        menuProps={{
                            items: [
                                {
                                    key: 'componentTypeView',
                                    itemType: ContextualMenuItemType.Header,
                                    text: t('data-lang-lbl-displaytype'),
                                    itemProps: { lang: 'en-us' },
                                },{
                                    key: 'listView',
                                    iconProps: { iconName: 'BulletedList' },
                                    text: t('data-lang-btn-list'),
                                    itemProps: { styles: {item: {backgroundColor: inputParam_Component.componentTypeId === enum__ComponentType.LIST ? "#e8e8e8" : ""}} },
                                    onClick: () => inputParam_OnChangeRowDisplayType(enum__ComponentType.LIST, inputParam_Component),
                                },{
                                    key: 'chartView',
                                    iconProps: { iconName: 'Financial' },
                                    text: t('data-lang-btn-chart'),
                                    itemProps: { styles: {item: {backgroundColor: inputParam_Component.componentTypeId === enum__ComponentType.CHART ? "#e8e8e8" : ""}} },
                                    onClick: () => inputParam_OnChangeRowDisplayType(enum__ComponentType.CHART, inputParam_Component),
                                },{
                                    key: 'simpleView',
                                    iconProps: { iconName: 'NumberField' },
                                    text: t('data-lang-btn-simple'),
                                    itemProps: { styles: {item: {backgroundColor: inputParam_Component.componentTypeId === enum__ComponentType.SIMPLELIST ? "#e8e8e8" : ""}} },
                                    onClick: () => inputParam_OnChangeRowDisplayType(enum__ComponentType.SIMPLELIST, inputParam_Component),
                                },/*{
                                    key: 'simpledetails',
                                    iconProps: { iconName: 'NumberSequence' },
                                    text: t('data-lang-btn-simpledetails'),
                                    itemProps: { styles: {item: {backgroundColor: inputParam_Component.componentTypeId === 4 ? "#e8e8e8" : ""}} },
                                    onClick: () => inputParam_OnChangeRowDisplayType(4, inputParam_Component),
                                },*/{
                                    key: 'colorView',
                                    iconProps: { iconName: 'BackgroundColor' },
                                    text: t('data-lang-btn-backgroundcolor'),
                                    itemProps: { styles: {item: {backgroundColor: inputParam_Component.componentTypeId === enum__ComponentType.SIMPLECOLORLIST ? "#e8e8e8" : ""}} },
                                    onClick: () => inputParam_OnChangeRowDisplayType(enum__ComponentType.SIMPLECOLORLIST, inputParam_Component),
                                },
                                { key: 'divider_aggregation', itemType: ContextualMenuItemType.Divider },
                                {
                                    key: 'aggregationType',
                                    itemType: ContextualMenuItemType.Header,
                                    text: t('data-lang-lbl-timeaggregation'),
                                    itemProps: { lang: 'en-us' },
                                },{
                                    key: 'notimeaggregation',
                                    iconProps: { iconName: 'History' },
                                    text: t('data-lang-lbl-notimeaggregation'),
                                    onClick: () => inputParam_OnChangeRowAggregationTime(false, inputParam_DataSerie.elementId, inputParam_DataSerie.dataserieId)
                                },{
                                    key: 'defftimeaggregation',
                                    iconProps: { iconName: 'Recent' },
                                    text: t('data-lang-lbl-defftimeaggregation'),
                                    onClick: () => inputParam_OnChangeRowAggregationTime(true, inputParam_DataSerie.elementId, inputParam_DataSerie.dataserieId)
                                },
                                { key: 'divider_2', itemType: ContextualMenuItemType.Divider },
                                {
                                    key: 'dataserieinfo',
                                    itemType: ContextualMenuItemType.Header,
                                    text: t('data-lang-lbl-kpi'),
                                    itemProps: { lang: 'en-us' },
                                },{
                                    key: enum__BUTTONKEYS_KPI.EDIT_BOARD_DATASERIE_INFO,
                                    iconProps: { iconName: 'Info' },
                                    text: t('data-lang-btn-info'),
                                    onClick: () => inputParam_OnOpenPanel("view", null, inputParam_DataSerie),
                                },{
                                    key: enum__BUTTONKEYS_KPI.CLOSE_BOARD_DATASERIE,
                                    iconProps: { iconName: 'Lock12' },
                                    text: t('data-lang-btn-closedataserie'),
                                    onClick: () => inputParam_OnOpenPanel("close", null, inputParam_DataSerie),
                                    hidden: !(inputParam_DataSerie !== null ? (_priv_canCloseDataserie.value && _priv_canCloseDataserie.mode === __enum_PageMode.Edit) : false)
                                },
                                { key: 'divider_3', itemType: ContextualMenuItemType.Divider },
                                {
                                    key: 'serieActionsVariableValue_hiddenOnlyObserverHeader',
                                    itemType: ContextualMenuItemType.Header,
                                    text: t('data-lang-lbl-actions'),
                                    itemProps: { lang: 'en-us' },
                                    hidden: !(inputParam_DataSerie !== null ? (canEdit || (_priv_canDelete?.value ?? false)) : false)
                                },{
                                    key: enum__BUTTONKEYS_KPI.VIEW_BOARD_DATASERIEVALUE,
                                    iconProps: { iconName: 'View' },
                                    text: t('data-lang-btn-viewvalue'),
                                    onClick: () => inputParam_OnOpenPanel(
                                        "view2",
                                        __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId) !== undefined ? __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).type : null,
                                        inputParam_DataSerie,
                                        inputParam_SetCalendarType),
                                },{
                                    key: enum__BUTTONKEYS_KPI.ADD_BOARD_DATASERIEVALUE,
                                    iconProps: { iconName: 'Add' },
                                    text: t('data-lang-btn-addvalue'),
                                    onClick: () => inputParam_OnOpenPanel(
                                        "add",
                                        __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId) !== undefined ? __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).type : null,
                                        inputParam_DataSerie,
                                        inputParam_SetCalendarType),
                                    hidden: !(inputParam_DataSerie !== null ? canEdit : false)
                                },{
                                    key: enum__BUTTONKEYS_KPI.EDIT_BOARD_DATASERIEVALUE,
                                    iconProps: { iconName: 'Edit' },
                                    text: t('data-lang-btn-editvalue'),
                                    onClick: () => inputParam_OnOpenPanel(
                                        "edit",
                                        __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId) !== undefined ? __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).type : null,
                                        inputParam_DataSerie,
                                        inputParam_SetCalendarType),
                                    hidden: !(inputParam_DataSerie !== null ? canEdit : false)
                                },{
                                    key: enum__BUTTONKEYS_KPI.DELETE_BOARD_DATASERIEVALUE,
                                    iconProps: { iconName: 'Delete' },
                                    text: t('data-lang-btn-deletevalue'),
                                    onClick: () => inputParam_OnOpenPanel(
                                        "delete",
                                        __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId) !== undefined ? __KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).type : null,
                                        inputParam_DataSerie,
                                        inputParam_SetCalendarType),
                                        hidden: !(inputParam_DataSerie !== null ? (_priv_canDelete?.value ?? false) : false)
                                    },
                                { key: 'divider_compare', itemType: ContextualMenuItemType.Divider },
                                {
                                    key: 'compareChartOptions',
                                    itemType: ContextualMenuItemType.Header,
                                    text: t('data-lang-lbl-compareseries'),
                                    itemProps: { lang: 'en-us' },
                                },{
                                    key: 'compareChartCompare',
                                    disabled: inputParam_SelectedDataserieToPanel ?
                                        (inputParam_SelectedDataserieToPanel.dataserieId === inputParam_DataSerie.dataserieId || inputParam_SelectedDataserieToPanel.measurementPeriodId !== inputParam_DataSerie.measurementPeriodId)
                                        ? true : false : false,
                                    iconProps: { iconName: 'Equalizer' },
                                    text: t('data-lang-btn-compare'),
                                    onClick: () => inputParam_OnSelectSerieToCompareOnChart(inputParam_DataSerie, __enum_ChartDataserieInputType.MULTIPLE)
                                },{
                                    key: 'compareChartClear',
                                    iconProps: { iconName: 'ClearFilter' },
                                    text: t('data-lang-btn-clear'),
                                    onClick: inputParam_OnChartDataBindClearCompareClick,
                                }
                            ].filter(x => inputParam_HideAggregationButtons ? x.key.indexOf('View') === -1 : true)
                            ///.filter(x => objBoard.l_structure.length > 1 ? x.key.indexOf('VariableValue') === -1 : true)
                            //.filter(x => inputParam_ShowOnlyInfoView && objBoard.l_structure.length > 1 ? x.key.indexOf('aggregation') === -1 : true)
                            .filter(x => inputParam_ShowOnlyInfoView && aux_structure[0].l_structure.length > 1 ? x.key.indexOf('compare') === -1 : true)
                            .filter(x => inputParam_ShowOnlyInfoView && aux_structure[0].l_structure.length === 1 ? x.key.indexOf('aggregation') === -1 : true)
                            .filter(x => inputParam_ShowOnlyInfoView && !canEdit === true ? x.key.indexOf('_hiddenOnlyObserverHeader') === -1 : true)
                        }}
                    />
                </div>
      );
}

ChangeComponentType.propTypes = {
    inputParam_OnChangeRowDisplayType: PropTypes.func.isRequired,
    inputParam_OnChangeRowAggregationTime: PropTypes.func.isRequired,
    inputParam_OnSelectSerieToCompareOnChart: PropTypes.func.isRequired,
    inputParam_OnChartDataBindClearCompareClick: PropTypes.func.isRequired,
    inputParam_OnOpenPanel: PropTypes.func.isRequired,
    inputParam_Component: PropTypes.object.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_SelectedDataserieToPanel: PropTypes.object,

    inputParam_HideAggregationButtons: PropTypes.bool.isRequired,
    
};


export default ChangeComponentType;